import { Clapperboard, ExternalLink } from 'lucide-react'

import { Anchor } from '@/components/ui/Anchor'
import { Badge } from '@/components/ui/badge'
import { posthogOrgUrl } from '@/lib/posthogLinks'

/** The customer's org in PostHog: its people, their events and their session replays. */
export function PosthogOrgPill({ orgId }: { orgId: string }) {
  const href = posthogOrgUrl(orgId)
  if (!href) return null

  return (
    <Anchor href={href} target="_blank" rel="noopener noreferrer" title="Open the org in PostHog">
      <Badge variant="secondary" className="hover:bg-ink-200 h-7 rounded-sm">
        <Clapperboard />
        PostHog
        <ExternalLink />
      </Badge>
    </Anchor>
  )
}
